import { getStoredUser } from "./authSession";

const getToken = () => {
  const user = getStoredUser();
  if (user) {
    const { token } = user;
    return {
      headers: {
        "x-auth-token": token,
      },
    };
  }
};

export default getToken;
